import {
  ARTIST_SORT,
  PLAYLIST_DATE_SORT,
  RELEASE_DATE_SORT,
  SORT_DIRECTION_ASC,
  SORT_DIRECTION_DESC,
  TITLE_SORT,
  TRACK_DATE_SORT,
} from '@disco/constants/SortTypes'
import {
  ALBUM_VIEW,
  ARTIST_VIEW,
  DEFAULT_VIEW,
  PLAYLIST_VIEW,
  TRACK_VIEW,
} from '@disco/constants/ViewTypes'

export type SortIcon =
  | 'alpha-asc'
  | 'alpha-desc'
  | 'date-newest'
  | 'date-oldest'
  | 'calendar'
  | 'tag'

export type Option = {
  textIcon?: string
  icon?: string
  label: string
  value: string
  group?: string
  sortIcon?: SortIcon
  disabled?: boolean
  tooltip?: string
}
const TAG_FILTER_STRING = 'Filter by tags...'
export const tagFilterOption: Option = {
  value: TAG_FILTER_STRING,
  label: TAG_FILTER_STRING,
  sortIcon: 'tag',
}
export const artistOptions: Array<Option> = [
  {
    value: `${TITLE_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'Name: A-Z',
    group: 'Sort by',
    sortIcon: 'alpha-asc',
  },
  {
    value: `${TITLE_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Name: Z-A',
    group: 'Sort by',
    sortIcon: 'alpha-desc',
  },
]
export const channelPlaylistOptions: Array<Option> = [
  {
    value: `${PLAYLIST_DATE_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Newest',
    group: 'Sort by',
    sortIcon: 'date-newest',
  },
  {
    value: `${PLAYLIST_DATE_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'Oldest',
    group: 'Sort by',
    sortIcon: 'date-oldest',
  },
  {
    value: `${TITLE_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'A-Z',
    group: 'Sort by',
    sortIcon: 'alpha-asc',
  },
  {
    value: `${TITLE_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Z-A',
    group: 'Sort by',
    sortIcon: 'alpha-desc',
  },
]
export const playlistOptions: Array<Option> = [
  ...channelPlaylistOptions,
  tagFilterOption,
]
export const trackOptions: Array<Option> = [
  {
    value: `${ARTIST_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'Artist: A-Z',
    group: 'Sort by',
    sortIcon: 'alpha-asc',
  },
  {
    value: `${ARTIST_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Artist: Z-A',
    group: 'Sort by',
    sortIcon: 'alpha-desc',
  },
  {
    value: `${TRACK_DATE_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Newest',
    group: 'Sort by',
    sortIcon: 'date-newest',
  },
  {
    value: `${TRACK_DATE_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'Oldest',
    group: 'Sort by',
    sortIcon: 'date-oldest',
  },
  {
    value: `${TITLE_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'Title: A-Z',
    group: 'Sort by',
    sortIcon: 'alpha-asc',
  },
  {
    value: `${TITLE_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Title: Z-A',
    group: 'Sort by',
    sortIcon: 'alpha-desc',
  },
  {
    value: `${RELEASE_DATE_SORT} ${SORT_DIRECTION_DESC}`,
    label: 'Newest',
    group: 'Sort by release date',
    sortIcon: 'calendar',
  },
  {
    value: `${RELEASE_DATE_SORT} ${SORT_DIRECTION_ASC}`,
    label: 'Oldest',
    group: 'Sort by release date',
    sortIcon: 'calendar',
  },
]
export const libViewOptions: Array<Option> = [
  {
    value: DEFAULT_VIEW,
    label: 'Playlists',
  },
  {
    value: TRACK_VIEW,
    label: 'Tracks',
  },
  {
    value: ALBUM_VIEW,
    label: 'Albums',
  },
  {
    value: ARTIST_VIEW,
    label: 'Artists',
  },
]
// "All" is the absence of a type filter, which the search state models as
// `false`; Radix Tabs needs a string value, hence the empty string.
export const searchTypeOptions: Array<Option> = [
  {
    value: '',
    label: 'All',
  },
  {
    value: 'track',
    label: 'Tracks',
  },
  {
    value: 'playlist',
    label: 'Playlists',
  },
  {
    value: 'album',
    label: 'Albums',
  },
  {
    value: 'artist',
    label: 'Artists',
  },
]
export const channelViewOptions: Array<Option> = [
  {
    value: DEFAULT_VIEW,
    label: 'View All',
    icon: ' ',
  },
  {
    value: PLAYLIST_VIEW,
    label: 'Playlists',
    icon: 'playlist',
  },
  {
    value: TRACK_VIEW,
    label: 'Tracks',
    icon: 'track',
  },
  {
    value: ALBUM_VIEW,
    label: 'Albums',
    icon: 'album',
  },
]
